import { createRouter, createWebHistory } from "vue-router";
import { verifyToken } from '../api';
import store from '../store';

const router = createRouter({
        history: createWebHistory(),
        routes: [
                { path: "/", component: () => import("../views/HomePage.vue"), meta: { title: "Domů" } },
                { path: "/sign-in", component: () => import("../views/SignIn.vue"), meta: { title: "Přihlášení" } },
                { path: "/public-report", component: () => import("../views/PublicReport.vue"), meta: { title: "Nahlásit koloběžku" } },
                { path: "/resolve/:token", component: () => import("../views/ResolvePage.vue"), meta: { title: "Vyřešení hlášení" } },
                { path: "/company-reports/:company", component: () => import("../views/CompanyReports.vue"), meta: { title: "Firemní portál" } },
                { path: "/report", component: () => import("../views/Report.vue"), meta: { title: "Nahlásit koloběžku", requiresAuth: true } },
                { path: "/feed", component: () => import("../views/FeedPage.vue"), meta: { title: "Tabulka", requiresAuth: true } },
                { path: "/statistics", component: () => import("../views/StatisticsPage.vue"), meta: { title: "Statistiky", requiresAuth: true } },
                { path: "/okruh", component: () => import("../views/PatrolRoutePage.vue"), meta: { title: "Doporučený okruh", requiresAuth: true } },
                { path: "/user-management", component: () => import("../views/UserManagement.vue"), meta: { title: "Správa uživatelů", requiresAuth: true } },
                { path: "/settings", component: () => import("../views/Settings.vue"), meta: { title: "Nastavení", requiresAuth: true } },
                { path: "/create-user", component: () => import("../views/CreateUser.vue"), meta: { title: "Nový uživatel", requiresAuth: true } },
                { path: "/public-reports", component: () => import("../views/PublicReportsManagement.vue"), meta: { title: "Veřejná hlášení", requiresAuth: true } },
                { path: "/parking-prediction", component: () => import("../views/ParkingPrediction.vue"), meta: { title: "Parkovací místa", requiresAuth: true, requiresAdmin: true } },
                { path: "/:pathMatch(.*)*", component: () => import("../views/NotFound.vue"), meta: { title: "Stránka nenalezena" } },
        ],
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (!requiresAuth) {
    return next();
  }

  const hadToken = Boolean(localStorage.getItem('token'));
  const tokenValid = await verifyToken();

  if (!tokenValid) {
    store.commit('setLoggedIn', false);
    store.commit('setRole', null);
    localStorage.removeItem('role');
    // Měl token a už neplatí = vypršelo přihlášení; po loginu vrátit zpět
    next(hadToken
      ? { path: '/sign-in', query: { expired: '1', redirect: to.fullPath } }
      : '/sign-in');
  } else {
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
    if (requiresAdmin && localStorage.getItem('role') !== 'admin') {
      next('/');
    } else {
      next();
    }
  }
});

/**
 * Titulek karty prohlížeče podle stránky — dřív měly všechny stránky
 * stejný název z index.html a v historii ani v panelu karet nešly rozlišit.
 */
const APP_NAME = 'ScooterPatrol';

router.afterEach((to) => {
  const title = to.meta?.title;
  document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
});

export default router;
